import { render } from "./GrupoTelasView.vue?vue&type=template&id=107c5ac1"
import script from "./GrupoTelasView.vue?vue&type=script&lang=js"
export * from "./GrupoTelasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__